import styled from 'styled-components';
import {FONTS} from '@fupa/fupa-uikit';

const ButtonContainer = styled.div`
  display: flex;
  margin: 1rem 0;
  justify-content: space-between;
`;

const Emph = styled.span`
  white-space: nowrap;
  font-weight: ${FONTS.bold};
`;

export {ButtonContainer, Emph};
